import React from 'react';
import './ImageQuote.css';

// A photograph, optionally paired with a quote. The quote sits on a solid panel
// (over the image on wide screens, below it on narrow ones) so it stays legible
// on any photograph. The author is always shown; the full source is in <cite>.
// `eager` is for an image at the top of the page; everything else lazy-loads.
export function Illustration({ image, className = '', eager = false }) {
  return (
    <div className={`illustration ${className}`.trim()} style={{ aspectRatio: `${image.width} / ${image.height}` }}>
      <img
        src={image.src} alt={image.alt} width={image.width} height={image.height}
        loading={eager ? 'eager' : 'lazy'} decoding="async"
      />
    </div>
  );
}

export default function ImageQuote({ image, quote, layout = 'overlay', className = '', eager = false }) {
  return (
    <figure className={`image-quote image-quote--${layout} ${className}`.trim()}>
      <Illustration image={image} eager={eager} />
      {quote && (
        <div className="image-quote-panel">
          <blockquote className="image-quote-text">
            <p>{quote.lead ? `${quote.lead} ` : ''}&ldquo;{quote.text}&rdquo;</p>
          </blockquote>
          <figcaption className="image-quote-caption">
            <span className="image-quote-author">{quote.author}</span>
            <cite className="image-quote-source">
              {quote.sourceUrl ? <a href={quote.sourceUrl} target="_blank" rel="noreferrer">{quote.source}</a> : quote.source}
            </cite>
          </figcaption>
        </div>
      )}
    </figure>
  );
}
